import React, {useState} from "react";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import {Button, Form, Row, Col, Collapse, FormControl, FormGroup} from 'react-bootstrap';


function Adicionar({onAdicionar}){
    const [novoEvento, setNovoEvento] = useState({
        title: '',
        start: '',
        end: '',
        desc:'',
        color:'',
        tipo:'',
    });

    const options = ['Maçã', 'Banana', 'Laranja', 'Manga', 'Pera', 'Abacaxi'];
    const [selected, setSelected] = useState([]);

    const [expanded, setExpanded] = useState('false');

    const handleChange = (e) =>{
        const {name,value} = e.target;
        setNovoEvento({...novoEvento, [name]:value});

    }

    const handleToggleExpanded = (e) => {
        e.stopPropagation();
        setExpanded(!expanded);
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        let d3 = new Date(novoEvento.start);
        d3.setHours(d3.getHours() + 1);
        console.log('d3: ',d3);
        novoEvento.end = d3;

        if(novoEvento.title && novoEvento.start){
            const startDate = new Date(novoEvento.start);
            const endDate = new Date(novoEvento.end);
            if(startDate >= endDate){
                alert('A data de início deve ser inferior à data de término.');
                return;
            } 
        }
        onAdicionar(novoEvento);
        setNovoEvento({
            title: '',
            start: '',
            end: '',
            desc:'',
            color:'',
            tipo:'',
        })
    }

    return(
    <div className="adicionar p-3 rouded border border-white" style={{backgroundColor: '#e9ecef', color:'#212529'}}>
        <h3> Agendar</h3>
        <Form onSubmit={handleSubmit}>
            <Form.Group controlID='formBasicTitle'>
            <Form.Label> Servidor </Form.Label>
            <Form.Control type="text" placeholder="Digite o Servidor" name="title" value={novoEvento.title} onChange={handleChange}/>
            </Form.Group>
            <Row>
                <Col xs={12}>
                <Form.Group controlId="formBasicStart">
                    <Form.Label> Início </Form.Label>
                    <Form.Control type="datetime-local" name="start" value={novoEvento.start} onChange={handleChange}/>
                </Form.Group>
                </Col>

            </Row>
            <Collapse in={expanded}>
                <div>
                    <div>
                        <Form.Group controlId="formBasicDesc">
                            <Form.Label> Descrição </Form.Label>
                            <Form.Control type="text"  placeholder="Digite a Descrição" name="desc" value={novoEvento.desc} onChange={handleChange}/>
                        </Form.Group>
                    </div>
                    <Row>
                            <Col xs={3}>
                                <Form.Group controlId='formBasicColor'>
                                    <Form.Label>Cor</Form.Label>
                                    <Form.Control type='color' name='color' value={novoEvento.color} onChange={handleChange}/>
                                </Form.Group>
                            </Col>
                            <Col xs={9}>
                                <Form.Group controlId='formBasicTipo'>
                                    <Form.Label htmlFor="adv-select">Advogado</Form.Label>
                                    
                                    <Form.Select type='text' placeholder='Digite o Advogado' id="adv-select" name='tipo' value={novoEvento.tipo} onChange={handleChange}>
                                        <option value="Dra. Leticia">Dra. Leticia</option> 
                                        <option value="Dr. Magno">Dr. Magno</option>
                                        <option value="Dr. Thiago">Dr. Thiago</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                </div>

            </Collapse>
            <Button
               variant='primary'
               type='button'
               onClick={handleToggleExpanded}
               style={{marginTop: '10px', float:'right'}}>
               {expanded ? <i class="bi bi-chevron-double-up"></i> : <i class="bi bi-chevron-double-down"></i>}
            </Button>
            <Button
               variant='success'
               type='submit'
               style={{marginTop: '10px', marginRtight: '10px'}}
               disabled={!novoEvento.title || !novoEvento.start}>
               Salvar
            </Button>
            </Form>
    </div>
    )
}
export default Adicionar;